import { useState, useCallback, useEffect } from 'react'
import { listFiles, deleteFile, type ListOptions } from '@/services/api'
import type { FileItem } from '@/types'

export function useFiles(options: ListOptions = {}) {
  const { category = 'all', scope, q, limit, offset } = options
  const [files, setFiles] = useState<FileItem[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchFiles = useCallback(async () => {
    setLoading(true)
    setError(null)

    const response = await listFiles({ category, scope, q, limit, offset })

    if (response.success) {
      setFiles(response.data)
    } else {
      setError(response.error || 'Failed to fetch files')
    }

    setLoading(false)
  }, [category, scope, q, limit, offset])

  const removeFile = useCallback(async (key: string) => {
    const response = await deleteFile(key)

    if (response.success) {
      setFiles((prev) => prev.filter((f) => f.key !== key))
    }

    return response
  }, [])

  useEffect(() => {
    fetchFiles()
  }, [fetchFiles])

  return {
    files,
    loading,
    error,
    refresh: fetchFiles,
    removeFile,
  }
}
